import { Flex, Heading } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import styled from "styled-components";
import { useAppContext } from "../context/appContext/appContext";
import { FormInput, Logo, UIAlert } from "../components";

const ResetPassword = () => {
  const { showAlert, resetPassword, isLoading, displayAlert } =
    useAppContext();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const email = searchParams.get("email");
  const token = searchParams.get("token");
  const linkIsValid = Boolean(email && token);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => navigate("/register"), 3000);
      return () => clearTimeout(timer);
    }
  }, [success, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!password || password.length < 6 || password !== confirmPassword) {
      displayAlert();
      return;
    }
    const ok = await resetPassword({ email, token, password });
    if (ok) setSuccess(true);
  };

  return (
    <Flex
      bgImage="url('ace.jpg')"
      bgPosition="center"
      bgRepeat="no-repeat"
      minH="100vh"
      justify="center"
      align="center"
    >
      <Wrapper>
        <form className="form" onSubmit={onSubmit}>
          <Logo
            image={"apple-touch-icon.png"}
            size={"50px"}
            color={"#63aab5"}
          />
          <Heading as="h2" size="lg" color="headline.400" fontStyle="italic">
            Reset Password
          </Heading>
          {showAlert && <UIAlert />}
          {!linkIsValid ? (
            <p style={{ textAlign: "center" }}>
              This reset link is invalid. Please request a new one.
            </p>
          ) : success ? (
            <p style={{ textAlign: "center" }}>
              Your password has been reset. Redirecting you to login...
            </p>
          ) : (
            <>
              <FormInput
                inputType="password"
                name="password"
                value={password}
                labelText="New Password"
                handleChange={(e) => setPassword(e.target.value)}
              />
              <FormInput
                inputType="password"
                name="confirmPassword"
                value={confirmPassword}
                labelText="Confirm Password"
                handleChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button
                className="form-btn"
                bg="headline.400"
                color="white"
                disabled={isLoading}
              >
                Reset Password
              </button>
            </>
          )}
          <p>
            <Link to="/register" style={{ color: "#63aab5" }}>
              Back to Login
            </Link>
          </p>
        </form>
      </Wrapper>
    </Flex>
  );
};
export default ResetPassword;

const Wrapper = styled.section`
  padding: 0 16px;
  box-sizing: border-box;

  .form {
    min-height: 400px;
    background-color: white;
    border: 3px solid #63aab5;
    margin: 0 auto;
    width: min(90vw, 500px);
    display: flex;
    box-sizing: border-box;
    align-items: center;
    border-radius: 5px;
    flex-direction: column;
    padding: clamp(16px, 5vw, 20px);
    gap: 20px;
    justify-content: center;
  }

  .form-btn {
    width: min(180px, 100%);
    margin: 5px;
    margin-top: 10px;
    cursor: pointer;
    border-radius: 5px;
    color: white;
    font-weight: bold;
    background-color: #63aab5;
    border: none;
    padding: 5px;
  }
`;
